import { BadgeCheck } from "lucide-react";

const CERTIFICATIONS = [
  "Solvent Extraction",
  "Plant Lifting Machines & Pressure Vessel",
  "Storage Tank Calibration",
  "Power Press Machine",
  "Safety Auditor",
  "SMPV Competency",
  "Fire Auditor",
];

export default function Certifications() {
  return (
    <section data-testid="certifications-section" className="py-16 bg-white border-y border-navy/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div className="flex items-center gap-3">
            <BadgeCheck className="h-5 w-5 text-safety" />
            <span className="kicker !text-safety">Certified Competencies</span>
          </div>
          <div className="flex flex-wrap gap-2.5">
            {CERTIFICATIONS.map((c, i) => (
              <span
                key={c}
                data-testid={`certification-pill-${i}`}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-steel-light border border-navy/10 text-navy text-sm font-medium hover:bg-navy hover:text-white hover:border-navy transition-colors"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-safety" />
                {c}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
